import { render, staticRenderFns } from "./BulkUpdateNewProductCommissionsModal.vue?vue&type=template&id=3b578e1f&lang=html&"
import script from "./BulkUpdateNewProductCommissionsModal.vue?vue&type=script&lang=js&"
export * from "./BulkUpdateNewProductCommissionsModal.vue?vue&type=script&lang=js&"
import style0 from "./BulkUpdateNewProductCommissionsModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports